import React from "react";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { ThemeConfigFieldSchema } from "../../../config/theme-configure";

interface CheckboxInputProps {
  value?: string;
  onChange?: (value: string) => void;
  field?: ThemeConfigFieldSchema;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  value,
  onChange,
  field,
}: CheckboxInputProps) => {
  const handleChange = (event: CheckboxChangeEvent) => {
    onChange?.(String(event.target.checked));
  };

  return (
    <Checkbox checked={value === "true"} onChange={handleChange}>
      {field?.label}
    </Checkbox>
  );
};
